import { Observable } from 'rxjs';
import { ProblemForUserModel } from 'src/app/store/problem-user/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractProblemForUserApiService {
  public abstract getActiveProblems(userId: number): Observable<InteractorResponse<ProblemForUserModel[]>>;
  public abstract subscriptionProblem(problemId: number, userId: number): Observable<InteractorResponse<ProblemForUserModel>>;
  public abstract unSubscriptionProblem(subscriptionId: number): Observable<InteractorResponse<ProblemForUserModel>>;
  public abstract lockProblem(problemId: number, userId: number): Observable<InteractorResponse<ProblemForUserModel>>;
}
